import { Badge, Box, Flex, Stack, Text, Tooltip } from "@chakra-ui/react";
import { formatDistanceToNow } from "date-fns";
import { CiChat1 } from "react-icons/ci";
import { FaWhatsapp, FaFacebookMessenger, FaInstagram, FaTelegram } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";

const CHANNEL_META = {
  whatsapp:        { icon: FaWhatsapp,         color: "#25D366", label: "WhatsApp" },
  fb_messenger:    { icon: FaFacebookMessenger, color: "#0084FF", label: "Facebook Messenger" },
  instagram:       { icon: FaInstagram,         color: "#E1306C", label: "Instagram" },
  telegram:        { icon: FaTelegram,          color: "#2CA5E0", label: "Telegram" },
};

function ChannelIcon({ channel }) {
  const meta = CHANNEL_META[channel];
  if (meta) {
    const Icon = meta.icon;
    return <Tooltip label={meta.label}><span><Icon color={meta.color} size={16} /></span></Tooltip>;
  }
  return <Tooltip label="Web"><span><TbWorld color="#4A90E2" size={16} /></span></Tooltip>;
}

function Avatar({ name, channel }) {
  const meta = CHANNEL_META[channel];
  const bg = meta?.color || "#4A90E2";
  const letter = (name || "?")[0].toUpperCase();
  return (
    <Box
      w="36px"
      h="36px"
      borderRadius="full"
      bg={bg}
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontWeight="bold"
      fontSize="sm"
      flexShrink={0}
    >
      {letter}
    </Box>
  );
}

export default function LiveUsers({ activeUsers, currentUserProps, selectedChatBg, chatBg, chatTextColor }) {
  const { currentUser, onSetCurrentUser } = currentUserProps;
  const users = Object.keys(activeUsers);
  return (
    <Stack spacing={2}>
      {users.map((activeUser, index) => {
        const user = activeUsers[activeUser];
        const displayName = user.contactName || `Visitor ${index + 1}`;
        const lastMsgTime = user.lastMessageAt
          ? formatDistanceToNow(user.lastMessageAt, { addSuffix: true })
          : null;
        const isSelected = currentUser?.user === activeUser;
        return (
          <Box
            cursor="pointer"
            p={2}
            onClick={() =>
              onSetCurrentUser({
                user: activeUser,
                messages: user.messages,
                accepted: user.accepted,
              })
            }
            bg={isSelected ? selectedChatBg : chatBg}
            color={isSelected ? "white" : chatTextColor}
            borderRadius="md"
            key={index}
            boxShadow="md"
          >
            <Flex alignItems="center" gap={2} mb={1}>
              <Avatar name={displayName} channel={user.channel} />
              <Box flex={1} minW={0}>
                <Flex alignItems="center" gap={1}>
                  <ChannelIcon channel={user.channel} />
                  <Text fontWeight="semibold" fontSize="sm" noOfLines={1}>
                    {displayName}
                  </Text>
                </Flex>
                {lastMsgTime && (
                  <Text fontSize="xs" opacity={0.7}>
                    {lastMsgTime}
                  </Text>
                )}
              </Box>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center">
              <Badge colorScheme={user.accepted ? "green" : "gray"}>
                {user.accepted ? "Accepted" : "Pending"}
              </Badge>
              <Badge colorScheme={user.active ? "green" : "gray"}>
                {user.active ? "Online" : "Offline"}
              </Badge>
              <Flex justifyContent="center" alignItems="center" gap={1}>
                <Text>{user.messages?.length || 0}</Text>
                <CiChat1 />
              </Flex>
            </Flex>
          </Box>
        );
      })}
    </Stack>
  );
}
